import { NgModule } from "@angular/core";
import { AdminCommonModule } from "../admin-common.module";
import { TransactionLogManagementComponent } from "./transaction-log-management.component";

@NgModule({
    declarations: [
        TransactionLogManagementComponent
    ],
    imports: [
        AdminCommonModule
    ]
})
export class TransactionLogModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/transaction-log/transaction-log.module.ts